<div class="container">
    <ng-container *ngFor="let stage of stages">
        <button class="btn btn-secondary btn-sm mr-2 mt-2" *ngIf="stage.showTitles" [class.active]="currentStageCode === stage.alternateName" (click)="gotoStage(stage.alternateName, currentStageCode === stage.alternateName)">
                {{ stage.name | i18n }}
            </button>
    </ng-container>
</div>